import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from './../../../shared/services/courier.service';
import { GetCourierCarListRequest, GetCourierCarListResponse } from './../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from './../../../shared/services/active-user-local-data.service';
import { StartNewVoucherDataClass } from './../../../shared/models/start-new-voucher-data.model';

@Component({
  templateUrl: 'pick-car.component.html',
  styleUrls: ['./pick-car.component.scss']
})
export class PickCarComponent implements OnInit {

  carListResponse: GetCourierCarListResponse | null = null;
  loading: boolean = true;
  searchText: string = '';

  get filteredCars() {
    if (!this.carListResponse?.cars) return [];
    if (this.searchText.length > 0) {
      const lowerSearch = this.searchText.toLowerCase();
      return this.carListResponse.cars.filter(car =>
        (car.number && car.number.toLowerCase().includes(lowerSearch)) ||
        (car.description && car.description.toLowerCase().includes(lowerSearch))
      );
    }
    return this.carListResponse.cars;
  }

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadCarList();
  }

  loadCarList() {
    this.loading = true;
    const request: GetCourierCarListRequest = {};
    this.courierService.getCarList(request).subscribe(
      (response: GetCourierCarListResponse) => {
        if (response?.cars) {
        } else {
          console.warn('No cars array in response:', response);
        }
        this.carListResponse = response;
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching car list:', error);
        this.loading = false;
      }
    );
  }

  continueNextStep(carId: number, carNumber: string | null) {
    const pickedCar = this.carListResponse?.cars.find(car => car.id === carId);
    const newVoucherData: StartNewVoucherDataClass = {
      carId: carId,
      carNumber: carNumber && carNumber.trim() ? `Jauns: ${carNumber}` : 'Jauns: 0',
      rulesAccepted: false,
      clientId: undefined,
      regionId: undefined,
      routeId: undefined,
      checklistAnswers: [],
      comments: [],
      existingFaults: []
    };
    this.activeUserLocalDataService.setStartNewVoucherData(newVoucherData);
    if (pickedCar?.canUseTrailer) {
      this.router.navigate(['/pick-trailer']);
    } else {
      this.router.navigate(['/rule-check']);
    }
  }

  navigateToVoucher() {
    this.router.navigate(['/voucher']);
  }
}